/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dashboard-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;background-color:#f0f0f0;padding:.5rem;z-index:1}.dashboard-header[_ngcontent-%COMP%]   .grower[_ngcontent-%COMP%]{flex-grow:1}.dashboard-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;flex-direction:row;position:absolute;top:0;bottom:0;left:0;right:0}\n/*# sourceMappingURL=dashboard.component.css.map*/"];
export { styles as styles };
